import React, { useMemo, useState } from "react";
import { API } from "@/lib/api";
import ReimagePanel from "@/components/admin/images/ReimagePanel";
import { POLICY_LABELS } from "@/components/admin/images/ImagePolicySettings";
import { Row } from "../_ui";

/** Per-site image policy (saved with the Settings form) + card preview + re-image job. */
export default function ImagePolicyPanel({ site, form, setField }) {
  const [previewKey, setPreviewKey] = useState(0);
  const siteIds = useMemo(() => [site.id], [site.id]);
  const policy = form.image_policy || "network";
  const src = `${API}/images/card-preview?site_id=${encodeURIComponent(site.id)}&v=${previewKey}-${site.palette}-${site.font_pair}`;
  return (
    <>
      <Row label="Article images">
        <div className="space-y-2 max-w-xl">
          <select
            data-testid="sitedetail-image-policy" value={policy} onChange={(e) => setField("image_policy", e.target.value)}
            className="admin-input bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm w-full"
          >
            {Object.entries(POLICY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          {policy === "source" && (
            <div data-testid="sitedetail-image-policy-warning" className="text-[11px] text-amber-400 mono">
              Re-hosting publishers' photos exposes this domain to image-licensing claims. Use only for feeds whose terms allow redistribution.
            </div>
          )}
          <div className="text-[11px] text-zinc-500">Saved with this form. Takes effect for the next rewritten article; use re-image below for existing ones.</div>
        </div>
      </Row>
      <Row label="Branded card preview">
        <div className="space-y-2 max-w-xl">
          <img data-testid="sitedetail-card-preview" src={src} alt="Branded card preview" className="w-full max-w-md border border-zinc-800 rounded-sm" />
          <button type="button" data-testid="sitedetail-card-preview-refresh" onClick={() => setPreviewKey((k) => k + 1)} className="text-[11px] text-zinc-500 hover:text-zinc-300 mono uppercase tracking-widest">refresh preview</button>
        </div>
      </Row>
      <Row label="Existing articles">
        <ReimagePanel siteIds={siteIds} force />
      </Row>
    </>
  );
}
